<template>
  <EmailDeliveryTable
    fetchAction="EmailDeliveryStore/getQueueList"
    resendEmailAction="EmailDeliveryStore/resendEmail"
    deleteEmailAction="EmailDeliveryStore/deleteEmail"
    placeholder="No emails are queued."
    :autoRefresh="true"
  />
</template>

<script>
import EmailDeliveryTable from "./EmailDeliveryTable";
export default {
  components: {
    EmailDeliveryTable,
  },
};
</script>
